import { trackGoogleConversion } from './google';
import { initYandexMetrika } from './yandex';

export function initAnalytics(): void {
  initYandexMetrika();
}

export {
  initYandexMetrika,
  trackGoogleConversion,
};
